import { isString } from "radashi";

// https://developer.mozilla.org/en-US/docs/Web/API/NavigatorUAData
type NavigatorUAData = {
  brands: Array<string>;
  mobile: boolean;
  platform: string;
};

export function isMac() {
  const source =
    "userAgentData" in navigator && isNavigatorUAData(navigator.userAgentData)
      ? navigator.userAgentData.platform
      : navigator.platform;
  const lowerCaseSource = source.toLowerCase();

  return lowerCaseSource.startsWith("mac") || lowerCaseSource === "iphone";
}

function isNavigatorUAData(value: unknown): value is NavigatorUAData {
  return (
    "platform" in (value as NavigatorUAData) &&
    isString((value as NavigatorUAData).platform)
  );
}
